import React, { useEffect, useState } from "react";

import dayjs from 'dayjs';
import {
  Typography,
  Row,
  Col,
  Input,
  Select,
  Button,
  Space,
  Table,
  Form,
  Tooltip,
  Popconfirm,
  Modal,
  Tag,
  Card,
  DatePicker,
  InputNumber,
  message,
  Checkbox,
  Dropdown,
  Menu,
} from "antd";
import {
  CalculatorOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
  InfoOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  ReloadOutlined,
  SearchOutlined,
  WalletOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { JournalCentralService } from "../Services/JournalCentralService";
import { TraitementService } from "../Services/TraitementService";
import confirm from "antd/lib/modal/confirm";
import { printJournalSaisie } from "../Services/PrintJournalSaisieService";
import { CotisationService } from "../Services/CotisationService";
import { AdherentsService } from "../Services/AdherentsService";
import "../Pages/CSS/Traitement.css";
const { Title } = Typography;
const { Option } = Select;

const SaisieCotisations = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();
  const journalCentralService = new JournalCentralService();
  const traitementsoinsService = new TraitementService();
  const cotisationService = new CotisationService();
  const adherentsService = new AdherentsService();
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [journalData, setJournalData] = useState([]);
  const [adherentData, setAdherentData] = useState([]);
  const [compteGenData, setCompteGenData] = useState([]);
  const [getDetails, setGetDetails] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [compteTiersOptions, setCompteTiersOptions] = useState([]);
  const [isCompteTiersDisabled, setIsCompteTiersDisabled] = useState(true);
  const [selectJournal, setSelectJournal] = useState("ALL");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [years, setYears] = useState([]);
  const [paramData, setParamData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [debitAmount, setDebitAmount] = useState(0);
  const [creditAmount, setCreditAmount] = useState(0);
  const [totalDebitModal, setTotalDebitModal] = useState(0);
  const [totalCreditModal, setTotalCreditModal] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const fetchData = async () => {
    setIsLoading(true);
    if (selectedYear && selectedMonth) {
      try {
        const data = await cotisationService.getAllCotis(
          selectedYear,
          selectedMonth
        );
        let filteredData = data;

        setTableData(filteredData);
        const yearsData = await journalCentralService.getComptaExercices();
        setYears([...yearsData].sort((a, b) => b - a));
        const listCotis = await cotisationService.getTypeCotis();
        setJournalData(listCotis);
        const listAdht = await adherentsService.getAllAdherents();
        setAdherentData(listAdht);
        /* const getParam = await traitementsoinsService.getParamComptable();
        setParamData(getParam); */

        const totalDebitCalculated = filteredData.reduce(
          (acc, curr) => acc + (curr.debit || 0),
          0
        );
        const totalCreditCalculated = filteredData.reduce(
          (acc, curr) => acc + (curr.credit || 0),
          0
        );

        setTotalDebit(totalDebitCalculated);
        setTotalCredit(totalCreditCalculated);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setIsLoading(false);
      }
    }
  };



  const fetchDataInit = async () => {
    try {
      const getParam = await traitementsoinsService.getParamComptable();
      setParamData(getParam);
      const monthFromParamData = dayjs(getParam.datedeb).format("MM");
      setSelectedMonth(monthFromParamData);
      const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
      setSelectedYear(yearFromParamData)
      // Appel à fetchData() une fois que selectedMonth est défini
      await fetchData();
    } catch (error) {
      console.error("Erreur lors de l'initialisation des paramètres :", error);
    }
  };

  useEffect(() => {
    const totalDebitFiltered = filteredData.reduce(
      (acc, curr) => acc + (curr.debit || 0),
      0
    );
    const totalCreditFiltered = filteredData.reduce(
      (acc, curr) => acc + (curr.credit || 0),
      0
    );
    setTotalDebit(totalDebitFiltered);
    setTotalCredit(totalCreditFiltered);
  }, [filteredData]);

  // useEffect unique pour l'initialisation
  useEffect(() => {
    fetchDataInit();
  }, []);


  const fetchListAll = async () => {
    try {
      const data = await journalCentralService.getPlanCompta();
      setCompteGenData(data);
    } catch (error) {
      console.log("Erreur lors de la récupération des adhérents:", error);
    }
  };

  useEffect(() => {
    console.log(
      `Compte Tiers est ${isCompteTiersDisabled ? "désactivé" : "activé"}.`
    );
  }, [isCompteTiersDisabled]);

  useEffect(() => {
    console.log("Options de Compte Tiers :", compteTiersOptions);
  }, [compteTiersOptions]);
  /* 
    useEffect(() => {
      fetchData();
    }, [selectedYear, selectedMonth, selectJournal]); */

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handleDeleteline = async () => {
    try {
      const selectedData = tableData.filter((item) =>
        selectedRowKeys.includes(item.numligne)
      );
      const docData = selectedData.map((item) => item.numligne);

      Modal.confirm({
        title: "Êtes-vous sûr de vouloir supprimer le journal ?",
        icon: <ExclamationCircleOutlined />,
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await cotisationService.deleteCotis(docData);
            await fetchData();
            setSelectedRowKeys([]);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel: () => {
          console.log("Suppression annulée");
        }
      });


    } catch (error) {
      console.error("Erreur lors de la confirmation de la suppression :", error);
    }
  };

  const exportToExcel = (data) => {
    // Utilisation de XLSX pour exporter les données
    // Installez d'abord la librairie : npm install xlsx file-saver
    import("xlsx").then(XLSX => {
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Cotisations");
      XLSX.writeFile(wb, "cotisations_export.xlsx");
    });
  };

  const handlePrint = async () => {
    // Vérification si des lignes sont sélectionnées
    if (selectedRowKeys.length === 0) {
      message.warning("Veuillez sélectionner au moins une ligne à imprimer.");
      return;
    }

    setIsLoading(true);
    try {
      // Filtrage des données de la table pour obtenir les lignes sélectionnées
      const selectedData = tableData.filter(
        (item) => selectedRowKeys.includes(item.numligne) // Assurez-vous que 'numpiece' est bien la clé unique correspondant à votre sélection
      );

      // Préparation des données pour l'impression ()
      const docData = selectedData.map((item) => item.numligne); // Exemple: envoie juste les 'numpiece'

      // Appel du service d'impression avec les données préparées
      await journalCentralService.printCompta(docData);
      printJournalSaisie(); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddClick = async () => {
    form.resetFields(); // Réinitialiser les champs du formulaire au cas où ils contiendraient des données précédentes
    setIsModalVisible(true); // Afficher le modal
    setModalTitle("Ajouter une nouvelle entrée");
    await fetchListAll(); // Assurez-vous que cette opération est terminée avant de continuer

    try {
      const getParam = await traitementsoinsService.getParamComptable();
      setParamData(getParam);
      form.setFieldsValue({ datetrait: dayjs(getParam.datedeb) });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des paramètres comptables :",
        error
      );
    }
  };
  useEffect(() => {
    const newTotalDebit = getDetails.reduce(
      (sum, record) => sum + (record.debit || 0),
      0
    );
    const newTotalCredit = getDetails.reduce(
      (sum, record) => sum + (record.credit || 0),
      0
    );

    setTotalDebitModal(newTotalDebit);
    setTotalCreditModal(newTotalCredit);
  }, [getDetails]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      // Récupérer les informations de compte basées sur l'adhérent sélectionné
      const selectedAdherent = adherentData.find(
        (adherent) => adherent.codeadht === values.codeadht
      );
      // Récupérer les informations de compte et libellé basées sur le journal sélectionné
      const selectedJournal = journalData.find(
        (journal) => journal.codej === values.codej
      );
      const payload = {
        codej: values.codej,
        codesoc: values.codeadht,
        comptegen: selectedAdherent ? selectedAdherent.compte : null, // Utiliser une valeur par défaut ou gérer l'absence de correspondance
        contrepartie: selectedJournal ? selectedJournal.compte_rattache : null,
        credit: 0,
        datepiece: values.datepiece.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        datetrait: values.datetrait.format('YYYY-MM-DDT00:00:00.000[Z]'),
        debit: 0,
        freels: 0,
        libelle: selectedJournal
          ? selectedJournal.libelle
          : "COTISATION SALARIALE",
        montant: values.montant,
      };

      if (!payload.comptegen || !payload.contrepartie) {
        message.error("Des informations de compte sont manquantes.");
        return;
      }

      const response = await cotisationService.addCotis(payload);
      message.success("Saisie ajoutée avec succès.");
      setIsModalVisible(false);
      await fetchData();
      form.resetFields();
    } catch (error) {
      message.error(
        "Erreur lors de la soumission du formulaire : " + error.message
      );
      console.error("Erreur lors de l'envoi des données :", error);
    }
  };

  const resetTableData = () => {
    setGetDetails([]); // Réinitialiser les données de la table
  };

  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }
  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const monthOptions = [

    { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const handleEditClick = () => {
    message.warning("Pour modifier, il faut aller au niveau de saisie journal");
  };

  const columns = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => a.codej.localeCompare(b.codej), // Tri alphabétique
    },
    {
      title: "Date saisie",
      dataIndex: "datesaisie",
      key: "datesaisie",
      align: "center",
      sorter: (a, b) => dayjs(a.datesaisie).unix() - dayjs(b.datesaisie).unix(), // Tri par date
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {dayjs(record.datesaisie).locale("fr").format("DD MMM YYYY")}
        </div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      sorter: (a, b) => a.numpiece - b.numpiece, // Tri numérique
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingLeft: 5, paddingRight: 5 }}>
          {text}
        </div>
      ),
    },
    {
      title: "Code Soc",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      sorter: (a, b) => a.codesoc.localeCompare(b.codesoc), // Tri alphabétique
    },
    {
      title: "Société",
      dataIndex: "intitule",
      key: "intitule",
      align: "center",
      sorter: (a, b) => a.intitule.localeCompare(b.intitule), // Tri alphabétique
    },
    {
      title: "Mois trait",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) => dayjs(a.datetrait).unix() - dayjs(b.datetrait).unix(), // Tri par date
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {dayjs(record.datetrait).format("MMM YYYY")}
        </div>
      ),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => a.comptegen.localeCompare(b.comptegen), // Tri alphabétique
    },

    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => a.libelle.localeCompare(b.libelle), // Tri alphabétique
    },
    {
      title: "Mvts Debit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => a.debit - b.debit, // Tri numérique
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Mvts Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => a.credit - b.credit, // Tri numérique
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Comptabilisé",
      dataIndex: "lettrage",
      key: "lettrage",
      align: "center",
      sorter: (a, b) => a.lettrage.localeCompare(b.lettrage), // Tri alphabétique
      render: (text) => {
        let tagColor, tagText;

        switch (text) {
          case "Non":
            tagColor = "#f2b305";
            tagText = "Non";
            break;
          case "Oui":
            tagColor = "#46de04";
            tagText = "Oui";
            break;
          default:
            tagColor = "#000000";
            tagText = text;
        }

        return <Tag color={tagColor}>{tagText}</Tag>;
      },
    },


  ];


  useEffect(() => {
    fetchData(); // Appel pour récupérer les données du journal
    setFilteredData(tableData); // Initialiser filteredData avec les données du journal
  }, [selectedYear, selectedMonth, selectJournal]);

  useEffect(() => {
    setFilteredData(tableData); // Mettre à jour filteredData lorsque tableData change
  }, [tableData]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
    setSearchText(value); // Mettre à jour le texte de recherche
  };
  const handleCancel = () => {
    // Réinitialise les champs du formulaire
    setIsModalVisible(false); // Ferme le modal
    setEditingKey(null);
    resetTableData();
    // Mise à jour des états si vous utilisez des états pour gérer ces valeurs
    setDebitAmount(0);
    setCreditAmount(0);
    form.resetFields();
    setIsEditMode(false);
  };

  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };


  const allRowKeys = filteredData.map((record) => record.numligne);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = filteredData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
        },
      },
    ],
    getCheckboxProps: (record) => ({
      name: record.numligne,
      // Désactiver la case à cocher si l'état de la ligne est "Oui" (comptabilisé)
      disabled: record.lettrage === "Oui",
    }),
  };

  const handleDebitChange = (value) => {
    setDebitAmount(value || 0); // Met à jour le montant débit
    setCreditAmount(0); // Réinitialise le montant crédit
    form.setFieldsValue({ credit: 0 }); // Synchronise le formulaire
  };

  const isButtonDisabled = selectedRowKeys.length === 0;

  useEffect(() => {
    const selectedData = tableData.filter(
      (item) => selectedRowKeys.includes(item.numligne)
    );

    const solde = selectedData.reduce(
      (acc, item) => acc + (item.debit || 0) - (item.credit || 0),
      0
    );

    setButtonDisabled(solde !== 0);
  }, [selectedRowKeys, tableData]);

  const handleComptabiliser = async () => {

    const selectedData = tableData.filter(
      (item) => selectedRowKeys.includes(item.numligne) // Assurez-vous que ceci est correct
    );
    const solde = selectedData.reduce(
      (acc, item) => acc + (item.debit || 0) - (item.credit || 0),
      0
    );

    if (solde !== 0) {
      message.warning(
        "La somme des débits et crédits des lignes sélectionnées doit être égale à zéro."
      );
      return;
    }

    try {
      const result = await journalCentralService.comptabJournalCentral(
        selectedData
      );
      console.log(result);
      message.success("La comptabilisation a été effectuée avec succès.");
      await fetchData();
      setSelectedRowKeys([]);
    } catch (error) {
      message.error("Une erreur est survenue lors de la comptabilisation.");
      console.error(error);
    }
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <WalletOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Saisie Cotisation
        </span>
      </div>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <p>
            Solde débit:
            <span>
              <strong style={{ color: "#c40208" }}>
                {" "}
                {formatNumber(totalDebit)}
              </strong>
            </span>
          </p>
          <p>
            Solde crédit:
            <span>
              <strong style={{ color: "#c40208" }}>
                {" "}
                {formatNumber(totalCredit)}
              </strong>
            </span>
          </p>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={16}
          lg={16}
          xl={16}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          <Space wrap style={{ justifyContent: "flex-end" }}>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 100,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 140,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={setSelectedMonth}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            <Button
              icon={<PlusCircleOutlined />}
              type="primary"
              style={{ marginTop: 25 }}
              onClick={handleAddClick}
            >
              Ajouter
            </Button>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="print"
                    icon={<PrinterOutlined style={{ color: "#1890ff" }} />}
                    disabled={isButtonDisabled}
                    onClick={handlePrint}
                  >
                    Imprimer
                  </Menu.Item>
                  <Menu.Item
                    key="comptabiliser"
                    icon={<CalculatorOutlined style={{ color: "#1890ff" }} />}
                    disabled={isButtonDisabled}
                    onClick={handleComptabiliser}
                  >
                    Comptabiliser
                  </Menu.Item>
                  <Menu.Item
                    key="export"
                    icon={<FileExcelOutlined style={{ color: "#1890ff" }} />}
                    onClick={() => exportToExcel(filteredData)}
                  >
                    Exporter
                  </Menu.Item>
                  <Menu.Item
                    key="refresh"
                    icon={<ReloadOutlined style={{ color: "#1890ff" }} />}
                    onClick={() => fetchData()}
                  >
                    Actualiser
                  </Menu.Item>
                  <Menu.Item
                    key="delete"
                    danger
                    icon={<DeleteOutlined />}
                    disabled={isButtonDisabled}
                    onClick={handleDeleteline}
                  >
                    Supprimer
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <Button
                className="buttonRefresh"
                style={{
                  marginTop: 25,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontWeight: 500,
                }}
              >
                Actions <DownOutlined />
              </Button>
            </Dropdown>
          </Space>
        </Col>
      </Row>

      <Card style={{ padding: 0 }}>
        <Table
          dataSource={filteredData}
          scroll={{ x: true }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          showSorterTooltip={false}
          rowSelection={rowSelection}
          columns={columns}
          rowKey="numligne"
          title={() => (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>
                Nombre de ligne(s): <strong>{filteredData.length}</strong>
              </span>
              <Input
                className="search-input-highlight"
                placeholder="Rechercher..."
                allowClear
                prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                style={{ width: 250 }}
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          )}
        />
      </Card>
      <Modal
        title={isEditMode ? "Modification" : "Création"}
        open={isModalVisible}
        maskClosable={false}
        onOk={handleOk}
        style={{ top: 20 }}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" size="small" name="form_in_modal">

          <Form.Item
            name="codeadht"
            label="Société"
            rules={[{ required: true, message: "Champs requis" }]}
          >
            <Select
              showSearch
              placeholder="Selectionner"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {adherentData.map((adherent) => (
                <Option
                  key={adherent.codeadht}
                  value={adherent.codeadht}
                >{`${adherent.codeadht} - ${adherent.intitule}`}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="codej"
            label="Type Cotisation"
            rules={[{ required: true, message: "Champs requis" }]}
          >
            <Select
              showSearch
              placeholder="Type Cotisation"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {journalData.map((journal) => (
                <Option
                  key={journal.codej}
                  value={journal.codej}
                >{`${journal.codej} - ${journal.libelle}`}</Option>
              ))}
            </Select>
          </Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="datepiece"
                label="Date Pièce "
                initialValue={dayjs()}
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <DatePicker
                  disabledDate={disableFutureDates}
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="montant"
                label={`Montant(${formatNumber(debitAmount)})`}
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <InputNumber
                  value={debitAmount}
                  onChange={handleDebitChange}
                  min={0}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="datetrait"
            label="Date Traitement"
            rules={[{ required: true, message: "Champs requis" }]}
          >
            <DatePicker
              format="MMM.YYYY"
              picker="month"
              style={{ width: "55%" }}
              disabledDate={(current) => current && current > dayjs().endOf('day')}
              onChange={(date, dateString) => form.setFieldsValue({ datetrait: date })}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SaisieCotisations;
